<script>
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import Button from './Button.svelte';
  import { getTrad } from './js/AppState';
  import SGMSApi from './js/SGMSApi';
  const dispatch = createEventDispatcher();

  let email = "";

  function handleSubmit(e) {
    e.preventDefault()

    SGMSApi.sendActionEvent(e, "MailAccept")
    try{
      //window.Main.UpdateMail(email)

    } catch(e) {
      console.log("e", e)
    }
    dispatch("close")
  }

  function close(e) {
    SGMSApi.sendActionEvent(e, "MailRefuse")
    dispatch("close")
  }



</script>

<div class="mail-screen" transition:fade>
  <div class="mail-popup">
    <div class="close" on:click={close} />
    <div class="content">

      <div>{$getTrad("Ecran_Mail_01")}</div>
      <div>{$getTrad("Ecran_Mail_02")}</div>

      <form on:submit={handleSubmit}>
        <p><input required type="email" bind:value={email}  placeholder={$getTrad("Ecran_Mail_03")}></p>

        <div class="conditions">
          <input type="checkbox" required /> {$getTrad("Ecran_mail_conditions")}
          <a target="_blank" href={$getTrad("mail_data_rights_link")}>{$getTrad("Ecran_mail_know_more")}</a>
        </div>

        <div class="btn">
          <Button>{$getTrad("Ecran_Mail_04")}</Button>
        </div>
      </form>




    </div>
  </div>
</div>


<style>
  .mail-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(45, 68, 136, 0.8);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 10;
  }

  .mail-popup {
    position: relative;
    max-width: 410px;
    margin: 30px;

    display: flex;
    flex-direction: column;

    border-radius: 30px 30px 0 0;
    padding: 50px 40px;
    padding-bottom: 0;
    color: #fff;
    background: #00a7e6;
  }

  .mail-popup::after {
    content: "";
    position: absolute;
    top: 99%;
    left: 0;
    right: 0;

    height: 100px;
    background: url('../images/blue-bottom.png') no-repeat center center;
    background-size: 100% 100%;
  }

  .close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 20px;
    height: 20px;
    background: url('../images/closepopup.svg') no-repeat center center;
  }

  .content {
    text-align: center;
    overflow-y: auto;
  }

  form {
    margin-top: 30px;
  }

  .conditions {
    font-size: 12px;
    margin-bottom: 10px;
    text-align: left;
  }
  .conditions a{
    color: #fff;
    text-decoration: underline;
  }

  .btn { color: #000; }

  input[type="email"] {
    background: none;
    border: none;
    border-bottom: 2px solid white;
    outline: none;
    color: #fff;
  }
  ::-webkit-input-placeholder { color: white; }
  :-ms-input-placeholder { color: white; }
  ::placeholder { color: white; }

  input[type="checkbox"] {
    background: none;
    -webkit-appearance: none;
    appearance: none;

    position: relative;
    padding: 0;
    border: 3px solid #FFF;

    margin-bottom: 0;
    vertical-align: middle;

    width: 20px;
    height: 20px;
  }
  input[type="checkbox"]:checked {
    -webkit-appearance: none;
    appearance: none;
  }
  input[type="checkbox"]:checked::before {
    content: "✓";
    position: absolute;
    font-weight: bold;
    color: #fff;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;

  }

  @media screen and (max-width: 800px) {
    .mail-popup {
      max-height: 70%;
      margin-top: -50px;
    }
  }
</style>
